import { render } from "./LoadingModal.vue?vue&type=template&id=51621400"
import script from "./LoadingModal.vue?vue&type=script&lang=js"
export * from "./LoadingModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\kamiykei\\FitDish\\FitDish-WF\\fr\\ask\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__